export function getSelf(send) {
  return (...args) =>
    send(
      {
        path: '/v2/users/self',
        pathParameters: {},
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
